import { useState, useMemo } from 'react';

export const usePagination = (initialPage = 1, initialPageSize = 10) => {
  const [current, setCurrent] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [total, setTotal] = useState(0);

  const pageOptions = useMemo(
    () => ({
      page: current,
      take: pageSize,
    }),
    [current, pageSize]
  );

  const onChange = (page, size) => {
    setCurrent(page);
    if (size && size !== pageSize) {
      setPageSize(size);
    }
  };

  return {
    current,
    pageSize,
    total,
    setTotal,
    pageOptions,
    onChange,
    setCurrent,
    setPageSize,
  };
};
